import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

const ModalDialog = ({ isModalOpen, onConfirm, onCancel, title, children, confirmDisabled, confirmButtonText = 'Yes', cancelButtonText = 'No' }) => {
  return (
    <Dialog open={isModalOpen} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      {children && <DialogContent>{children}</DialogContent>}
      <DialogActions>
        <Button autoFocus onClick={onConfirm} color="primary" variant="contained" size="small" disabled={confirmDisabled}>
          {confirmButtonText}
        </Button>
        <Button onClick={onCancel} variant="contained" size="small" autoFocus>
          {cancelButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDialog;
